import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Row, FormControl, Button } from 'react-bootstrap';
import moment from 'moment';

import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';
import withForm from '../../hoc/withForm';
import { Multiselect } from 'multiselect-react-dropdown';

import { useAgentListReportStore } from '../../store/providers/AgentListReport';
import { useFranchiseStore } from '../../store/providers/Franchise';

import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';
import { isEmpty, isArray, orderBy } from 'lodash';

import Spinner from '../../components/Spinner/Spinner';
import Permission from '../../components/Permission/Permission';

import validations from './validations';
import './agentListReport.css';

import * as constants from '../../constants';
import OptionsHelper from '../../lib/OptionsHelper';

const SideMenu = React.lazy(() => import('../../components/SideMenu/SideMenu'));
const PageHeader = React.lazy(() => import('../../components/PageHeader/PageHeader'));
const InputCollection = React.lazy(() => import('../../components/InputCollection/InputCollection'));
const InformationModal = React.lazy(() => import('../../components/Modals/InformationModal/InformationModal'));

function AgentListReport(props) {
    const dispatch = useDispatch();

    const { listRecords, data: franchiseData } = useFranchiseStore();
    const { createRecord } = useAgentListReportStore();
    const [isMounted, setIsMounted] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [showInformationModal, setShowInformationModal] = useState(false);

    const pagePermission = constants.PERMISSION_REPORTS_AGENTLISTEXPORT;
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const [franchiseOptions, setFranchiseOptions] = useState([]);
    const [selectedFranchises, setSelectedFranchises] = useState([]);
    const franchiseDropdown = useRef(null);

    const [selectOptionsList, setSelectOptionsList] = useState([]);
    const [selectAgentStatusOptionsList, setSelectAgentStatusOptionsList] = useState([]);

    const submittedHandler = (e) => {
        e.preventDefault();

        let franchiseIds = [];
        franchiseIds = selectedFranchises.map((selectedFranchise) => {
            return selectedFranchise.id;
        })
        props.formData.FranchiseIds = franchiseIds;
        props.formData.franchiseIds = franchiseIds;

        var valid = props.formValidate(validations);
        if (valid) {
            props.formSubmitted();
            setShowInformationModal(true);
            createRecord(props.formData);
        }
    };

    const infoClickedHandler = () => {
        setShowInformationModal(false);
    };

    useEffect(() => {
        if (!isEmpty(franchiseData)) {
            if (franchiseData.scope === 'list'
                && franchiseData.status === 'success'
            ) {
                let options = [];
                if (!isEmpty(franchiseData)
                    && franchiseData.scope === 'list'
                    && franchiseData.status === 'success') {
                    const options = franchiseData.body.map((franchise) => {
                        return { id: franchise.id, name: `${franchise.name} (${franchise.instance})` }
                    });

                    setFranchiseOptions(options);
                }

                franchiseData.body.forEach((franchise) => {
                    if (franchise.demo) { return; }

                    let include = false;

                    if (isEmpty(franchise.terminatedOn)) { include = true; }

                    if (!include) {
                        const now = moment(new Date());
                        const days30 = moment(now).subtract(30, 'days');

                        if (moment(franchise.terminatedOn) > days30) { include = true; }
                    }

                    if (include) {
                        options.push({ id: franchise.id, name: `${franchise.instance.toUpperCase()}` });
                    }
                });

                options = orderBy(options, ['name']);
                options = [
                    { id: 0, name: 'All Instances' },
                    { id: -1, name: 'Corporate' },
                    { id: -2, name: 'Non-Corporate' }].concat(options);

                setFranchiseOptions(options);
            }

            setIsBusy(franchiseData.status === 'processing' && franchiseData.scope === 'list');
        }

    }, [franchiseData, props]);

    useEffect(() => {
        if (!hasPermission) { return; }
        if (isMounted) { return; }

        dispatch(breadcrumbAddRoute({ key: 'agentListReport', text: 'Agent List Export', path: window.location.pathname }));
        listRecords();

        const selectOptions = (
            [
                {
                    id: 1,
                    name: "Yes",
                    description: "Yes",
                },
                {
                    id: 0,
                    name: "No",
                    description: "No",
                },
            ]
        );

        setSelectOptionsList(OptionsHelper({ list: selectOptions, nameField: 'name', includeBlank: true, includeBlankName: 'Any' }));
    
        const selectAgentStatusOptions = (
            [
                {
                    id: 4,
                    name: "Active Agent",
                    description: "Active Agent",
                },
                {
                    id: 2,
                    name: "Active Prospect",
                    description: "Active Prospect",
                },
                {
                    id: 5,
                    name: "Cancelled Agent",
                    description: "Cancelled Agent",
                },
                {
                    id: 3,
                    name: "Cancelled Prospect",
                    description: "Cancelled Prospect",
                },
                {
                    id: 9,
                    name: "In Process",
                    description: "In Process",
                },                             
                {
                    id: 10,
                    name: "Membership Agent",
                    description: "Membership Agent",
                },
                {
                    id: 6,
                    name: "Severed Agent",
                    description: "Severed Agent",
                },
            ]
        );
        setSelectAgentStatusOptionsList(OptionsHelper({ list: selectAgentStatusOptions, nameField: 'name', includeBlank: true, includeBlankName: 'Any' }));

        setIsMounted(true);
    }, [isMounted, hasPermission, dispatch]);

    useEffect(() => {
        return () => {
            dispatch(breadcrumbRemoveRoute());
        };
    }, [dispatch]);

    const selectHandler = (list, item) => {
        const hasOneNewsGroupTypeSelected = isArray(list) && list.length > 1 && (list[0].id === 0 || list[0].id === -1 || list[0].id === -2);

        if (hasOneNewsGroupTypeSelected) { list.pop(); }

        if (!hasOneNewsGroupTypeSelected && isArray(list) && list.length > 1 && (item.id === 0 || item.id === -1 || item.id === -2)) {
            list.pop();
        }

        setSelectedFranchises(list);

        let franchiseIds = [];
        list.forEach((franchise) => franchiseIds.push(franchise.id));

        props.formChanged('franchiseIds', (isEmpty(franchiseIds) ? [] : franchiseIds.join(',')));
    };

    const removeHandler = (list, _item) => {
        setSelectedFranchises(list);

        let franchiseIds = [];

        list.forEach((franchise) => franchiseIds.push(franchise.id));

        props.formChanged('franchiseIds', (isEmpty(franchiseIds) ? [] : franchiseIds.join(',')));
    };

    return (
        <>
            <SideMenu activeKey="reports" />
            <div className="content-body">
                <Permission showDenied={true} pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit}/>
                { hasPermission && 
                    <>
                        {
                            (!isMounted || isBusy) && <Spinner text="Loading Agent List Export..." />
                        }
                        {
                            showInformationModal && <InformationModal
                                show={showInformationModal}
                                clicked={infoClickedHandler}
                                title="Agent List Export Submitted"
                                buttonText='OK! Got it!'>
                                <div>
                                    Agent List Export will take a little time to run.  Your request is currently being processed and will be emailed to you within the next few minutes.
                                </div>
                            </InformationModal>
                        }

                        <div style={{ paddingRight: '15px' }}>
                            <PageHeader title="Agent List Export" />
                            {
                                isMounted && (
                                    <Form onSubmit={(e) => submittedHandler(e)}>
                                        <Row>
                                            <div className="col-md-4">
                                                <InputCollection required labelText="Instances" errorMessage={props.formValidationCheck('franchiseIds')}>
                                                    <Multiselect
                                                        options={franchiseOptions}
                                                        displayValue="name"
                                                        disabled={isBusy}
                                                        placeholder="Select Instances..."
                                                        emptyRecordMsg="No Instances Available"
                                                        selectedValues={selectedFranchises}
                                                        ref={franchiseDropdown}
                                                        avoidHighlightFirstOption={true}
                                                        closeOnSelect={false}
                                                        onSelect={(list, item) => selectHandler(list, item)}
                                                        onRemove={(list, item) => removeHandler(list, item)}
                                                    />
                                                </InputCollection>
                                            </div>
                                            <div className="col-md-4">
                                                <InputCollection labelText="Agent Status" errorMessage={props.formValidationCheck('AgentStatusId')}>
                                                    <FormControl 
                                                        id="AgentStatusId" 
                                                        componentClass="select" 
                                                        onChange={(e) => props.formChanged(e.target.id, e.target.value)} 
                                                        defaultValue={props.formData['AgentStatusId'] || ''} 
                                                        disabled={isBusy}>
                                                        {selectAgentStatusOptionsList}
                                                    </FormControl>
                                                </InputCollection>
                                            </div>
                                        </Row>
                                        <Row>
                                            <div className="col-md-4">
                                                <InputCollection labelText="Hire Begin Date" errorMessage={props.formValidationCheck('HireBeginDate')}>
                                                    <FormControl id="HireBeginDate"
                                                        type="date"
                                                        disabled={isBusy}
                                                        maxLength={10}
                                                        onChange={(e) => props.formChanged(e.target.id, e.target.value)} 
                                                        defaultValue={props.formData['HireBeginDate'] || ''}>
                                                    </FormControl>      
                                                </InputCollection>                      
                                            </div>
                                            <div className="col-md-4">
                                                <InputCollection labelText="Hire End Date" errorMessage={props.formValidationCheck('HireEndDate')}>
                                                    <FormControl id="HireEndDate"
                                                        type="date"
                                                        disabled={isBusy}
                                                        maxLength={10}
                                                        onChange={(e) => props.formChanged(e.target.id, e.target.value)} 
                                                        defaultValue={props.formData['HireEndDate'] || ''}>
                                                    </FormControl>      
                                                </InputCollection>                      
                                            </div>
                                        </Row>
                                        <Row>
                                            <div className="col-md-4">
                                                <InputCollection labelText="Sever Begin Date" errorMessage={props.formValidationCheck('SeverBeginDate')}>
                                                    <FormControl id="SeverBeginDate"
                                                        type="date"
                                                        disabled={isBusy}
                                                        maxLength={10}
                                                        onChange={(e) => props.formChanged(e.target.id, e.target.value)} 
                                                        defaultValue={props.formData['SeverBeginDate'] || ''}>
                                                    </FormControl>      
                                                </InputCollection>                      
                                            </div>
                                            <div className="col-md-4">
                                                <InputCollection labelText="Sever End Date" errorMessage={props.formValidationCheck('SeverEndDate')}>
                                                    <FormControl id="SeverEndDate"
                                                        type="date"
                                                        disabled={isBusy}
                                                        maxLength={10}
                                                        onChange={(e) => props.formChanged(e.target.id, e.target.value)} 
                                                        defaultValue={props.formData['SeverEndDate'] || ''}>
                                                    </FormControl>      
                                                </InputCollection>                      
                                            </div>
                                        </Row>
                                        <Row>
                                            <div className="col-md-4">
                                                <InputCollection labelText="SSN Verified" errorMessage={props.formValidationCheck('SsnVerified')}>
                                                    <FormControl 
                                                        id="SsnVerified" 
                                                        componentClass="select" 
                                                        onChange={(e) => props.formChanged(e.target.id, e.target.value)} 
                                                        defaultValue={props.formData['SsnVerified'] || ''} 
                                                        disabled={isBusy}>
                                                        {selectOptionsList}
                                                    </FormControl>
                                                </InputCollection>
                                            </div>
                                            <div className="col-md-4">
                                                <InputCollection labelText="EIN Verified" errorMessage={props.formValidationCheck('EinVerified')}>
                                                    <FormControl 
                                                        id="EinVerified" 
                                                        componentClass="select" 
                                                        onChange={(e) => props.formChanged(e.target.id, e.target.value)} 
                                                        defaultValue={props.formData['EinVerified'] || ''} 
                                                        disabled={isBusy}>
                                                        {selectOptionsList}
                                                    </FormControl>
                                                </InputCollection>
                                            </div>
                                        </Row>
                                        <Row>
                                            <div className="col-md-4">
                                                <InputCollection labelText="AutoPay" errorMessage={props.formValidationCheck('IsAutoPay')}>
                                                    <FormControl 
                                                        id="IsAutoPay" 
                                                        componentClass="select" 
                                                        onChange={(e) => props.formChanged(e.target.id, e.target.value)} 
                                                        defaultValue={props.formData['IsAutoPay'] || ''} 
                                                        disabled={isBusy}>
                                                        {selectOptionsList}
                                                    </FormControl>
                                                </InputCollection>
                                            </div>
                                        </Row>
                                        <Row>
                                            <div className="col-md-12">
                                                <hr className="form-divider" />
                                                <div className="form-action-buttons">
                                                    <Button bsStyle="danger" variant="danger" type="submit" className="button-group-margin" disabled={!canEdit || isBusy}>
                                                        <i className="fa fa-play button-icon"></i>
                                                        { isBusy ? 'Busy...' : 'Run' }
                                                    </Button>
                                                </div>
                                            </div>
                                        </Row>
                                    </Form>
                                )
                            }
                        </div>
                    </>
                }
            </div>
        </>
    );
}

export default withAuthentication(withLayout(withForm(AgentListReport)));